import { StripeElementsOptions } from '@stripe/stripe-js';
import colors from 'src/theme/colors';
import Input from 'src/theme/components/Input';

import MontserratMedium from 'src/assets/fonts/Montserrat-Medium.woff';
import MontserratSemiBold from 'src/assets/fonts/Montserrat-SemiBold.woff';

const stripeStyles: StripeElementsOptions = {
  fonts: [
    { family: 'Montserrat', src: `url(${MontserratMedium})`, weight: '500' },
    { family: 'Montserrat-SemiBold', src: `url(${MontserratSemiBold})`, weight: '800' },
  ],
  appearance: {
    theme: 'stripe',
    rules: {
      '.Input': {
        boxShadow: (Input.base?.boxShadow as string) ?? 'none',
        fontFamily: 'Montserrat',
        color: colors.podcastShade500,
        borderRadius: Input.variants?.visual?.primary.borderRadius ?? '0.5rem',
        borderStyle: Input.variants?.visual?.primary.borderStyle ?? `solid`,
        borderColor: Input.variants?.visual?.primary.borderColor ?? colors.podcastShade300,
      },
      '.Input:focus': {
        outline: `2px solid ${colors.podcastPurple}`,
        border: 'none',
        boxShadow: 'none',
      },
      '.Label': {
        color: colors.podcastShade600,
        fontFamily: 'Montserrat-SemiBold',
        fontSize: '1rem',
        marginBottom: '0.5rem',
      },
      '.Tab': {
        boxShadow: 'none',
        fontFamily: 'Montserrat',
        borderRadius: Input.variants?.visual.primary.borderRadius ?? '0.5rem',
        border: `2px solid ${colors.podcastShade200}`,
      },
      '.Tab--selected': {
        backgroundColor: colors.podcastShade100,
        boxShadow: 'inset 0px -3px 10px rgba(205, 204, 227, 0.2)',
      },
      '.Tab:focus': {
        outline: `2px solid ${colors.podcastPurple}`,
      },
    },
  },
};

export default stripeStyles;
